export const colors = ['coral', 'skyblue', '#66c2a5', 'tan', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', 'coral', 'skyblue', 'tan', 'orange']
